<p *ngIf="duration">
  <strong>{{ duration }}</strong>
</p>
